import { Button, useTheme, useMediaQuery } from "@mui/material";
import React, { useEffect } from "react";
import { getAssessmentBottomBarStyle } from "../../components/customstyles/AssessmentBottomBar";
import { useAssessmentTabs } from "../../providers/AssessmentTabsProvider";
import { ChevronLeft } from "@mui/icons-material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { useAssessment } from "../../providers/AssessmentProvider";
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import { useShowErrorDiaglog } from "../../providers/ShowErrorDiaglogProvider";
import { useGuidedMode } from "../../providers/GuidedModeProvider";

const useStyles = () => {
  let theme = useTheme();
  return getAssessmentBottomBarStyle(theme);
};

function BottomBar() {
  const styles = useStyles();
  const location = useLocation();
  const { guidedMode } = useGuidedMode();
  const isMobile = useMediaQuery("(max-width: 900px)");
  let { selectedTab, moveNext, moveBack } = useAssessmentTabs();
  const history = useHistory();
  const { assessment, saveAssessmentData } = useAssessment();
  const { openOrCloseErrorDialog, updateHeaderText } = useShowErrorDiaglog();
  let assessmentSections = Object.keys(assessment);
  let section = assessmentSections[selectedTab];
  const getNexTabName = () => {
    let section = Object.keys(assessment)[selectedTab + 1];
    let text;
    try {
      text = assessment[section]["sectionName"];
    } catch {
      text = "";
    }
    return text;
  };
  const getButtonDesign = (selectedTab, value) => {
    if (selectedTab === 0) {
      if (value) {
        return { ...styles.nextButtonActive };
      } else {
        return { ...styles.nextButton };
      }
    } else {
      return { ...styles.nextButtonActive };
    }
  };
  const handleNextButton = async () => {
    let status = selectedTab + 1;
    await saveAssessmentData(status);
    moveNext();
  };
  const getPatientAndAssessmentId = () => {
    let patientId;
    let assessmentId;
    let pathname = location.pathname.substring(1);
    pathname = pathname.split("/");
    patientId = pathname[1];
    if (pathname.length > 3) {
      assessmentId = pathname[pathname.length - 1];
    }
    return { patientId, assessmentId };
  };
  const handleSubmitButton = async () => {
    let { patientId, assessmentId } = getPatientAndAssessmentId();
    let status = selectedTab + 1;
    if (!guidedMode) {
      status = 4;
    }
    let response = await saveAssessmentData(status);
    if (response?.status === 400) {
      updateHeaderText("Cannot re-submit assessment");
      openOrCloseErrorDialog(true);
    } else if (response?.status === 200) {
      assessmentId = response.data?.assessmentId;
      history.replace({
        pathname: `/patients/${patientId}/assessment/result/${assessmentId}`,
      });
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [selectedTab]);
  return (
    <div style={{ ...styles.bottomBar }}>
      {selectedTab !== 0 && guidedMode ? (
        <Button
          disableElevation
          variant="outlined"
          startIcon={<ChevronLeft />}
          onClick={moveBack}
          style={{ ...styles.backButton, ...styles.bottomBarButton }}
        >
          Back
        </Button>
      ) : (
        <></>
      )}

      {selectedTab === Object.keys(assessment).length || !guidedMode ? (
        <Button
          sx={{
            ...styles.guidedBottomBarButton,
            "&.Mui-disabled": {
              backgroundColor: "#E0E0E0",
              color: "#9E9E9E",
              opacity: 1,
            },
          }}
          disableElevation
          variant="contained"
          onClick={handleSubmitButton}
          disabled={!guidedMode && !assessment.bodyAreas.sectionCompleted}
        >
          Submit
        </Button>
      ) : selectedTab !== Object.keys(assessment).length - 1 ? (
        <Button
          style={{
            ...getButtonDesign(
              selectedTab,
              assessment[section]?.sectionCompleted
            ),
            ...styles.bottomBarButton,
          }}
          disableElevation
          variant="contained"
          endIcon={<ChevronRightIcon />}
          onClick={handleNextButton}
          disabled={
            selectedTab === 0 ? !assessment[section]?.sectionCompleted : false
          }
        >
          Next{!isMobile ? `: ${getNexTabName()}` : ""}
        </Button>
      ) : (
        <Button
          disableElevation
          variant="contained"
          style={{
            ...getButtonDesign(false),
            ...styles.bottomBarButton,
          }}
          // disabled={!assessment[section]["sectionCompleted"]}
          onClick={handleNextButton}
        >
          Review
        </Button>
      )}
    </div>
  );
}

export default BottomBar;
